import { motion } from 'motion/react'
import ActionButton from 'src/components/ActionButton'
import BlockTitle from 'src/components/BlockTitle'
import Picture from 'src/components/Picture'
import RichText from 'src/components/RichText'
import { mq, pxToRem, sizes } from 'src/theme'
import styled from 'styled-components'

export const Container = styled.section`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(56)};
  &:not(:first-child) {
    margin-block-start: var(--g_spacing__blocks);
  }
  @media ${mq(944)} {
    padding-inline: ${pxToRem(32)};
  }
`
export const _BlockTitle = styled(BlockTitle)`
  max-width: calc(100% - ${pxToRem(32)});
  margin-inline: auto;
  @media ${mq(sizes.tablet)} {
  }
  @media ${mq(944)} {
    max-width: none;
  }
`
export const Wrapper = styled(motion.div)`
  display: grid;
  grid-template-columns: ${pxToRem(16)} auto 1fr;
  grid-template-rows: auto auto auto;
  max-width: max(${pxToRem(944)}, calc(63vw + ${pxToRem(32)}));
  margin-inline-start: auto;
  padding-inline-end: ${pxToRem(16)};
  @media ${mq(944)} {
    padding-inline-end: 0;
    grid-template-columns: ${pxToRem(32)} auto 1fr;
  }
`
export const Deco = styled.div`
  position: relative;
  z-index: 1;
  grid-column: 1 / span 2;
  grid-row: 2 / span 1;
  aspect-ratio: 1;
  width: min(30vw, ${pxToRem(248)});
`
export const Shape = styled.div`
  position: absolute;
  inset: auto auto 0 0;
  height: 250%;
  width: 100%;
  @media ${mq(sizes.tablet)} {
    height: 280%;
  }
`

export const _Picture = styled(Picture)`
  position: relative;
  z-index: 2;
  grid-column: 2 / span 2;
  grid-row: 1 / span 1;
`
export const Content = styled.div`
  position: relative;
  z-index: 2;
  grid-column: 3 / span 1;
  grid-row: 2 / span 2;
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  gap: ${pxToRem(32)};
  max-width: max(47%, ${pxToRem(448)});
  padding: ${pxToRem(32)} 0 0 ${pxToRem(32)};
  margin-inline-start: auto;
  @media ${mq(944)} {
    padding-block-start: ${pxToRem(40)};
    gap: ${pxToRem(40)};
  }
`
export const _RichText = styled(RichText)`
  ${({ theme }) => theme.textStyles.m375_body}
`
export const _ActionButton = styled(ActionButton)`
  width: auto;
`
